export default "__VITE_ASSET__meYTQxXz__"